module.exports = __webpack_public_path__ + "img/gPay-Supplier.5a16b055.svg";